<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="top-level">
	<div class="label-row" [ngClass]="errorText.trim().length === 0 ? 'valid' : 'error'">
		{{ label }}
	</div>

	<button
		mat-icon-button
		class="left-button-style"
		[disabled]="componentIsDisabled || value === min"
		title="Minimum: {{ min }}"
		automationId="matSpinnerMin"
		(click)="handleMinusClick()"
	>
		<mat-icon>remove</mat-icon>
	</button>

	<input
		text
		class="input-style"
		[ngStyle]="{ 'font-size': fontSize }"
		step="1"
		size="{{ widthOfTextInChars }}"
		automationId="inputText"
		[formControl]="textFormControl"
		(keydown)="onKeyEvent($event)"
		(keypress)="onKeyEvent($event)"
		(keyup)="onKeyEvent($event)"
		(focus)="onTextFocus()"
		(blur)="onTextBlur()"
	/>

	<button
		mat-icon-button
		class="right-button-style"
		[disabled]="componentIsDisabled || value === max"
		title="Maximum: {{ max }}"
		automationId="matSpinnerMax"
		(click)="handlePlusClick()"
	>
		<mat-icon>add</mat-icon>
	</button>

	<div class="label-row error">
		{{ errorText }}
	</div>
</div>
